/**
 * Decision-agent replies sometimes include browsing-style markers like [1][2]
 * without footnote targets. Strip for display when we have no source URLs.
 */

const ORPHAN_CITATION_RE = /\[\d+\]/g;

export function stripOrphanCitationMarkers(text: string): string {
  if (!text) return text;
  let out = text.replace(ORPHAN_CITATION_RE, '');
  out = out.replace(/[ \t]+([.,;:!?])/g, '$1');
  out = out.replace(/ {2,}/g, ' ');
  out = out.replace(/[ \t]+\n/g, '\n');
  out = out.replace(/\n{3,}/g, '\n\n');
  return out.trim();
}
